// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Variant_Tag from "../Data.Variant.Tag/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var getField = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "label";
    }
})());
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var gSumTypeOptionsConstructo = function (dictIsSymbol) {
    var mkTag = Data_Variant_Tag.mkTag(dictIsSymbol)();
    return function (dictGetTranslation) {
        var getTranslation = Restaumatic_I18n.getTranslation(dictGetTranslation);
        return function (dictHasField) {
            var getField1 = Data_Record.getField(dictHasField);
            return function (dictHasField1) {
                var getField2 = Data_Record.getField(dictHasField1);
                return function () {
                    return {
                        gGetSumTypeOptions: function (p) {
                            return function (v) {
                                return [ new Data_Tuple.Tuple(mkTag(Type_Proxy["Proxy"].value), getField2(Type_Proxy["Proxy"].value)(getField1(Type_Proxy["Proxy"].value)(getTranslation(p)))) ];
                            };
                        }
                    };
                };
            };
        };
    };
};
var gEnumOptionsConstructorNo = function (dictIsSymbol) {
    return function (dictGetTranslation) {
        var getTranslation = Restaumatic_I18n.getTranslation(dictGetTranslation);
        return function (dictHasField) {
            var getField1 = Data_Record.getField(dictHasField);
            return {
                gGetEnumOptions: function (p) {
                    return function (wrap) {
                        return [ new Data_Tuple.Tuple(wrap(Data_Generic_Rep.NoArguments.value), getField(Type_Proxy["Proxy"].value)(getField1(Type_Proxy["Proxy"].value)(getTranslation(p)))) ];
                    };
                }
            };
        };
    };
};
var getOptions = function (dict) {
    return dict.getOptions;
};
var getMetadata = function (dict) {
    return dict.getMetadata;
};
var gGetSumTypeOptions = function (dict) {
    return dict.gGetSumTypeOptions;
};
var getSumTypeOptions = function (dictGeneric) {
    var repOf = Data_Generic_Rep.repOf(dictGeneric);
    return function (dictGSumTypeOptions) {
        var gGetSumTypeOptions1 = gGetSumTypeOptions(dictGSumTypeOptions);
        return function (p) {
            return mapFlipped(gGetSumTypeOptions1(p)(repOf(Type_Proxy["Proxy"].value)))(function (v) {
                return new Specular_Select.SingleOption({
                    key: v.value0,
                    label: v.value1,
                    disabled: false
                });
            });
        };
    };
};
var gSumTypeOptionsSum = function (dictGSumTypeOptions) {
    var gGetSumTypeOptions1 = gGetSumTypeOptions(dictGSumTypeOptions);
    return function (dictGSumTypeOptions1) {
        var gGetSumTypeOptions2 = gGetSumTypeOptions(dictGSumTypeOptions1);
        return function () {
            return function () {
                return {
                    gGetSumTypeOptions: function (p) {
                        return function (v) {
                            return append(mapFlipped(gGetSumTypeOptions1(p)(Type_Proxy["Proxy"].value))(function (v1) {
                                return new Data_Tuple.Tuple(coerce(v1.value0), v1.value1);
                            }))(mapFlipped(gGetSumTypeOptions2(p)(Type_Proxy["Proxy"].value))(function (v1) {
                                return new Data_Tuple.Tuple(coerce(v1.value0), v1.value1);
                            }));
                        };
                    }
                };
            };
        };
    };
};
var gGetEnumOptions = function (dict) {
    return dict.gGetEnumOptions;
};
var getEnumOptions = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictBoundedEnum) {
        return function (dictEnum) {
            return function (dictGEnumOptions) {
                var gGetEnumOptions1 = gGetEnumOptions(dictGEnumOptions);
                return function (p) {
                    return mapFlipped(gGetEnumOptions1(p)(to))(function (v) {
                        return new Specular_Select.SingleOption({
                            key: v.value0,
                            label: v.value1,
                            disabled: false
                        });
                    });
                };
            };
        };
    };
};
var gEnumOptionsSum = function (dictGEnumOptions) {
    var gGetEnumOptions1 = gGetEnumOptions(dictGEnumOptions);
    return function (dictGEnumOptions1) {
        var gGetEnumOptions2 = gGetEnumOptions(dictGEnumOptions1);
        return {
            gGetEnumOptions: function (p) {
                return function (wrap) {
                    return append(gGetEnumOptions1(p)(function ($66) {
                        return wrap(Data_Generic_Rep.Inl.create($66));
                    }))(gGetEnumOptions2(p)(function ($67) {
                        return wrap(Data_Generic_Rep.Inr.create($67));
                    }));
                };
            }
        };
    };
};
export {
    gGetEnumOptions,
    gGetSumTypeOptions,
    getMetadata,
    getOptions,
    getEnumOptions,
    getSumTypeOptions,
    gEnumOptionsSum,
    gEnumOptionsConstructorNo,
    gSumTypeOptionsSum,
    gSumTypeOptionsConstructo
};
